import styles from "./GoogleMeetInstallNote.module.scss";

import { useCallback } from "react";

import { useTranslation } from "react-i18next";

import chevronRight from "@/modules/coaching/booking/svgs/chevron-right.svg";
import googleMeet from "@/modules/coaching/booking/svgs/google-meet.svg";
import { sendNativeMessage } from "@/modules/coaching/booking/utils/sendNativeMessage";
import { GOOGLE_MEET_WEB_URL } from "@/modules/coaching/shared/consts/googleMeetUrls";
import { isInNativeWebView } from "@/modules/shared/utils/isInNativeWebView";

export const GoogleMeetInstallNote = () => {
  const { t } = useTranslation();
  const handleWebViewClick = useCallback(() => {
    sendNativeMessage({ eventName: "GOOGLE_MEET_REDIRECT" });
  }, []);

  const bannerContent = (
    <>
      <img src={googleMeet} alt="" className={styles.meetIcon} />
      <span className={styles.bannerText}>
        <span className={styles.downloadLabel}>
          {t("coachingSession.bookingConfirmation.googleMeetDownload")}
        </span>{" "}
        <span className={styles.domain}>
          {t("coachingSession.bookingConfirmation.googleMeetDomain")}
        </span>
      </span>
      <img src={chevronRight} alt="" className={styles.chevron} />
    </>
  );

  return (
    <div className={styles.note}>
      <h2 className={styles.heading}>
        {t("coachingSession.bookingConfirmation.googleMeetHeading")}
      </h2>
      {isInNativeWebView() ? (
        <button
          type="button"
          className={styles.banner}
          onClick={handleWebViewClick}
        >
          {bannerContent}
        </button>
      ) : (
        <a
          className={styles.banner}
          href={GOOGLE_MEET_WEB_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {bannerContent}
        </a>
      )}
      <p className={styles.computerCopy}>
        {t("coachingSession.bookingConfirmation.googleMeetComputerCopy")}
      </p>
    </div>
  );
};
